import React, { useState } from "react";
import { useNavigate } from "react-router-dom"; // Import useNavigate for navigation
import ToastMessage from "../ToastMessage/ToastMessage";
import { sendOtp } from "../../utils/request"; // Import your sendOtp API function
import "./login.css";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const navigate = useNavigate(); // Hook to navigate to another route

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError(""); // Reset error on submit

    try {
      const userSignInData = {
        email: email, // Assuming 'userData' contains the user's email
      };
      // Make API request to send OTP to the email
      const response = await sendOtp(userSignInData); // Assuming sendOtp is the function to send OTP
      if (response.code === 21) {
        setSuccessMessage("OTP sent successfully! Check your email.");
        // Store necessary data for OTP verification
        const responseData ={
          email: userSignInData.email || email,
          resendOtpTime: response?.resendOtpTime
        }
        sessionStorage.setItem(
          "otpVerificationData",
          JSON.stringify(responseData)
        );
        setTimeout(() => {
          // Navigate to /client/change-password route after success
          navigate("/otp-verification");
        }, 2000); // Delay the navigation to show the success message for 2 seconds
      } else {
        setError("Failed to send OTP. Please try again.");
      }
    } catch (err) {
      setError(err.message || "loginError");
      setError("An error occurred. Please try again.", err);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="flex-container">
      <div className="form-section">
        <div>
          <div>
            <h4 className="title">{"Forgot Password"}</h4>
            <p className="description">
              {
                "Enter your email address to receive an OTP to reset your password."
              }
            </p>
          </div>

          <div className="form-container">
            <form className="login-form" onSubmit={handleSubmit}>
              <div className="input-group">
                <input
                  type="email" // Use email type for validation
                  id="email"
                  placeholder=" "
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  autoComplete="email"
                />
                <label htmlFor="email">{"Email"}</label>
              </div>

              <button type="submit" disabled={isLoading}>
                {isLoading ? "Sending OTP..." : "Send OTP"}
              </button>

              <ToastMessage
                message={error || successMessage}
                type={error ? "error" : "success"}
              />
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
